import React from "react";
import { Avatar, Typography } from "antd";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
const { Text } = Typography;
const Patient = (props) => {
  const { record, tabindex } = props;
  let location = useLocation();
  const letter = record?.first_name?.charAt(0);
  const name = record && record?.surename + " " + record?.first_name;
  const isAdmin = location.pathname.includes("admin");
  const linkPath = record
    ? isAdmin
      ? `/admin/patients/${record.id}`
      : `/branches/${record.branch}/patients/${record.id}`
    : null;

  return (
    <div style={{ display: "flex", alignItems: "center", width: "100%" }}>
      {record?.avatar_url ? (
        <Avatar src={record.avatar_url} style={{ flexShrink: 0 }} />
      ) : (
        <Avatar
          style={{
            color: "#f56a00",
            backgroundColor: "#fde3cf",
            flexShrink: 0,
          }}
        >
          {letter}
        </Avatar>
      )}
      <Link
        style={{ color: "inherit", flexGrow: 1, minWidth: 0 }}
        to={{
          pathname: linkPath,
        }}
        tabIndex={tabindex}
      >
        <Text
          ellipsis={{ tooltip: name }}
          style={{
            padding: "0 10px",
            textDecoration: "underline",
            width: "100%",
            display: "block",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {name}
        </Text>
      </Link>
    </div>
  );
};

export default Patient;
